// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3VMX4","options":"AnswerScale_options__3NWg8","selected":"AnswerScale_selected__3XM_q"};